/* src/app/compliance/pages/compliance/compliance.component.scss */
.file-block {
  cursor: pointer;
  background: RGBA(255, 255, 255, 0.3);
  font-size: 10px;
}
.file-block:hover {
  background: RGBA(255, 255, 255, 0.7);
}
hr {
  margin: 0;
  padding: 0;
}
/*# sourceMappingURL=compliance.component.css.map */
